import React from 'react';
import { CalendarClock } from 'lucide-react';

const AdvanceNoticeBanner = () => (
  <div className="max-w-3xl mx-auto my-6 px-4">
    <div className="flex items-start gap-3 bg-amber-50 border border-amber-200 text-amber-800 rounded-xl px-4 py-3 text-sm">
      <CalendarClock className="w-5 h-5 flex-shrink-0 mt-0.5" />
      <p>
        Todos los pedidos se preparan <strong>con anticipación</strong> — no entregamos nada de un día
        para el otro. Al confirmar tu pedido por WhatsApp, coordinamos si la fecha que necesitás es posible.
      </p>
    </div>
  </div>
);

export default AdvanceNoticeBanner;
